import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h3 className="text-2xl font-playfair font-bold text-brand-cream mb-6" data-id="element-50">
      Política de Privacidad
    </h3>
    <div className="space-y-4 text-brand-gray text-sm leading-relaxed" data-id="element-51">
      <p data-id="element-52">
        <strong className="text-brand-cream" data-id="element-53">Última actualización:</strong>{' '}
        Marzo 2026
      </p>
      <p data-id="element-54">
        En El Código del Silencio, nos comprometemos a proteger tu privacidad.
        Esta política describe cómo recopilamos, usamos y protegemos tu
        información personal.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-55">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-56">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital, incluyendo: nombre, dirección de
        correo electrónico e información de pago.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-57">
        2. Uso de la Información
      </h4>
      <p data-id="element-58">
        Tu información se utiliza exclusivamente para: procesar tu pedido,
        enviarte el producto digital adquirido, y comunicarnos contigo respecto
        a tu compra. No compartimos, vendemos ni alquilamos tu información
        personal a terceros.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-59">
        3. Protección de Datos
      </h4>
      <p data-id="element-60">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-61">
        4. Cookies
      </h4>
      <p data-id="element-62">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-63">
        5. Tus Derechos
      </h4>
      <p data-id="element-64">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes comunicarte
        con nosotros a través de los canales disponibles.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-65">
        6. Cambios a esta Política
      </h4>
      <p data-id="element-66">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página.
      </p>
    </div>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-playfair font-bold text-brand-cream mb-6" data-id="element-67">
      Términos y Condiciones
    </h3>
    <div className="space-y-4 text-brand-gray text-sm leading-relaxed" data-id="element-68">
      <p data-id="element-69">
        <strong className="text-brand-cream" data-id="element-70">Última actualización:</strong>{' '}
        Marzo 2026
      </p>
      <p data-id="element-71">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, aceptas los siguientes términos y condiciones.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-72">
        1. Producto Digital
      </h4>
      <p data-id="element-73">
        "El Código del Silencio" es un producto digital (eBook en formato PDF)
        que se entrega electrónicamente a la dirección de correo proporcionada
        al momento de la compra.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-74">
        2. Entrega
      </h4>
      <p data-id="element-75">
        El acceso al producto se otorga de forma inmediata tras la confirmación
        del pago. Recibirás un enlace de descarga en tu correo electrónico.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-76">
        3. Uso Personal
      </h4>
      <p data-id="element-77">
        El contenido adquirido es para uso personal y exclusivo del comprador.
        Queda prohibida la reproducción, distribución, modificación o reventa
        del material sin autorización expresa.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-78">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-79">
        Todo el contenido, incluyendo textos, gráficos y diseño, está protegido
        por derechos de autor. Todos los derechos están reservados.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-80">
        5. Resultados
      </h4>
      <p data-id="element-81">
        Los resultados mencionados en esta página son basados en experiencias
        reportadas y no garantizan resultados idénticos para todos los usuarios.
        Los resultados individuales pueden variar.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-82">
        6. Política de Reembolso
      </h4>
      <p data-id="element-83">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Sin embargo, si experimentas problemas técnicos con la
        descarga, nos comprometemos a resolverlos.
      </p>

      <h4 className="text-lg font-semibold text-brand-cream pt-2" data-id="element-84">
        7. Limitación de Responsabilidad
      </h4>
      <p data-id="element-85">
        El contenido de este producto es informativo y educativo. No sustituye
        el consejo profesional de un psicólogo o terapeuta. En casos de
        situaciones graves, recomendamos buscar ayuda profesional.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center text-brand-gray/50 text-sm border-t border-brand-charcoal bg-brand-navy" data-id="element-86">
        <div className="flex items-center justify-center gap-4 mb-4" data-id="element-87">
          <button onClick={() => setActiveModal('privacy')} className="text-brand-gray/60 hover:text-brand-gold transition-colors duration-200 underline underline-offset-2" data-id="element-88">
            Política de Privacidad
          </button>
          <span className="text-brand-charcoal" data-id="element-89">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-brand-gray/60 hover:text-brand-gold transition-colors duration-200 underline underline-offset-2" data-id="element-90">
            Términos y Condiciones
          </button>
        </div>
        <p data-id="element-91">
          © {new Date().getFullYear()} El Código del Silencio. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-92">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-93">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-94">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-brand-slate border border-brand-charcoal rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-95">
              {/* Modal Header */}
              <div className="sticky top-0 bg-brand-slate/95 backdrop-blur-sm border-b border-brand-charcoal px-6 py-4 flex items-center justify-end rounded-t-2xl z-10" data-id="element-96">
                <button onClick={() => setActiveModal(null)} className="text-brand-gray/60 hover:text-brand-cream transition-colors duration-200 p-1" aria-label="Cerrar" data-id="element-97">
                  <X className="w-5 h-5" data-id="element-98" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="px-6 py-6 md:px-8 md:py-8" data-id="element-99">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}